<template>
	<div>
		<div style="display: flex; justify-content: space-around; align-items: center">
    		<div style="width:20%">
				<el-select v-model="type" placeholder="请先选择分类">
					<el-option
						v-for="item in types"
						:key="item.id"
						:label="item.name"
						:value="item.id"
						:disabled="item.pid == 0"
					></el-option>
				</el-select>
				<el-select v-model="status" placeholder="使用状态">
					<el-option
						label="未使用"
						value="0"
					></el-option>
					<el-option
						label="已使用"
						value="1"
					></el-option>
				</el-select>
          <el-select v-model="sex" placeholder="性别">
					<el-option
						label="未知"
						value="0"
					></el-option>
					<el-option
						label="男"
						value="1"
					></el-option>
            <el-option
						label="女"
						value="2"
					></el-option>
				</el-select>
          <el-select v-model="group" placeholder="分组">
            <el-option
                label="默认组"
                value="0"
            ></el-option>
            <el-option
                label="电销组"
                value="1"
            ></el-option>
          </el-select>
          <el-input type="text" placeholder="请输入批次" v-model="batch"></el-input>
          <p>
            <el-tag
                :key="tag"
                v-for="tag in tags"
                closable
                :disable-transitions="false"
                @close="handleTagsClose(tag)">
              {{tag}}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
          </p>
			</div>
			<div style="width: 50%">
				<el-input type="textarea" :rows="2" placeholder="请输入内容，格式：手机号,名字,性别,出生年月日(2020-02-02)" v-model="textarea"></el-input>
			</div>
			<div><el-button type="primary" @click="app()">查询</el-button></div>
			<div>
				<el-upload action="#" ref="upload" :show-file-list="false" :auto-upload="false" :on-change="upload"
					:limit="1">
					<el-button size="small" type="primary">上传文件</el-button>
				</el-upload>
			</div>
			<el-dropdown @command="handleCommand" v-if="tuichu">
				<span class="el-dropdown-link">{{ kkk }}<i class="el-icon-arrow-down el-icon--right"></i></span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="a">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<div v-if="dl">
				<el-button type="primary" @click="dialogVisible = true">登录</el-button>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="账号" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input type="password" v-model="ruleForm.password" autocomplete="true"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="ok()">确 定</el-button>
			</span>
		</el-dialog>
		<div style="margin-top: 15px;color: #ccc;" v-if="repeat_total != '' || repeat_db_num != ''">
			本次导入重复数据总计{{ repeat_total }}条,与数据库重复有{{ repeat_db_num }}条,入库数据有{{ luru }}条
		</div>
		<div style="margin-top: 15px;">
			<downloadexcel class="el-button el-button--primary" :name="'重复数据'" :data="repeat_list"
				:fields="{'重复数据':'item'}">
				导出重复数据
			</downloadexcel>
			<downloadexcel class="el-button el-button--primary" :name="'不重复数据'" :data="no_repeat_list"
				:fields="{'不重复数据':'item'}">
				导出不重复数据
			</downloadexcel>
		</div>
		<div v-if="tableData != ''">
			<h3>重复数据标</h3>
			<div style="padding: 30px">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="wzzh" label="微信账号"></el-table-column>
					<el-table-column prop="xncs" label="查询次数"></el-table-column>
					<el-table-column prop="cjsj" label="创建时间"></el-table-column>
					<el-table-column prop="name" label="分类"></el-table-column>
					<el-table-column prop="tag" label="标签"></el-table-column>
					<el-table-column prop="batch" label="批次"></el-table-column>
				</el-table>
			</div>
		</div>
		<div v-if="luru != '' || chongfu != ''">
			<h1>本次查询重复数据有{{ chongfu }}条,录入数据有{{ luru }}条</h1>
		</div>
	</div>
</template>

<script>
	import {
		settoken,
		gettoken,
		removetoken,
	} from "@/network/token";
	import {
		Login,
		GetTypes
	} from "@/network/login.js";
	import downloadexcel from "vue-json-excel";

	export default {
		components: {
			downloadexcel,
		},
		data() {
			return {
				ruleForm: {
					name: "",
					password: "",
				},
				rules: {
					name: [{
							required: true,
							message: "请输入账号",
							trigger: "blur"
						},
						{
							min: 3,
							max: 11,
							message: "长度在 3 到 9 个字符",
							trigger: "blur"
						},
					],
					password: [{
							required: true,
							message: "请输入密码",
							trigger: "blur"
						},
						{
							min: 3,
							max: 9,
							message: "长度在 3 到 9 个字符",
							trigger: "blur"
						},
					],
				},
				dialogVisible: false,
				tableData: [],
				chongfu: "",
				luru: "",
				repeat_total: '',
				repeat_db_num: '',
				repeat_list: [],
				no_repeat_list: [],
				textarea: "",
				dl: true,
				tuichu: false,
				tk: '',
				kkk: '',
				types: [],
				type: null,
				status: '0',
        batch: '',
        sex: '0',
        group: '1',
        tags: [],
        inputVisible: false,
        inputValue: '',
			};
		},
		methods: {
			handleCommand(command) {
				removetoken("token");
				localStorage.removeItem('username'); // 移除用户名
				this.tk = '';
				this.dl = true;
				this.tuichu = false;
				this.kkk = '';
				this.$message('账号退出成功');
			},
			ok() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.axios
							.post(
								"/api/wxuser/login",
								this.qs.stringify({
									account: this.ruleForm.name,
									password: this.ruleForm.password,
								})
							)
							.then((res) => {
								console.log(res);
								if (res.data.code == 1) {
									this.$message({
										message: "登录成功",
										type: "success",
										duration: 1000,
									});
									settoken(res.data.data.token);
									localStorage.setItem('username', res.data.data.username); // 存储用户名
									this.tk = res.data.data.token;
									this.kkk = res.data.data.username;
									this.dl = false;
									this.tuichu = true;
								} else {
									this.$message({
										message: "账号或密码错误",
										type: "error",
										duration: 1000,
									});
								}
							});
						this.ruleForm.name = "";
						this.ruleForm.password = "";
						this.dialogVisible = false;
					} else {
						return false;
					}
				});
			},
			handleClose(done) {
				this.$confirm("确认关闭？")
					.then((_) => {
						console.log(done);
						done();
					})
					.catch((_) => {});
			},
			app() {
				let s = gettoken("token");
				if (!s) {
					this.$message({
						message: "请登陆后查询",
						type: "error",
						duration: 1000,
					});
					return;
				}
				if (this.type == null) {
					this.$message({
						message: "您还未选择分类",
						type: "warning",
					});
					return;
				}
				let data = {
					token: this.tk,
					username: this.textarea,
					type: this.type,
					status: this.status,
          batch: this.batch,
          sex: this.sex,
          group: this.group,
          tags: this.tags
				};
        const loading = this.$loading({
          lock: true,
          text: '查询中，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
				Login(data)
					.then((res) => {
						this.tableData = res.list;
						this.chongfu = res.repeat_num;
						this.luru = res.sigin_num;
						this.repeat_total = res.repeat_total;
						this.repeat_db_num = res.repeat_db_num;

						// 处理 repeat_list
						this.repeat_list = res.repeat_list.map(function(item) {
							return {
								'item': item
							};
						});

						// 处理 no_repeat_list
						this.no_repeat_list = Object.values(res.no_repeat_list).map(function(item) {
							return {
								'item': item
							};
						});

            loading.close();

						// 打印数据进行检查
						console.log('Repeat List:', this.repeat_list);
						console.log('No Repeat List:', this.no_repeat_list);
					});
			},
			upload(file) {
				let reader = new FileReader();
				if (typeof FileReader === "undefined") {
					this.$message({
						type: "info",
						message: "您的浏览器不支持文件读取。",
					});
					return;
				}
				reader.readAsText(file.raw, "utf-8");
				var self = this;
				reader.onload = function(e) {
					self.textarea = e.target.result;
					self.$refs['upload'].clearFiles();
					self.app();
				};
			},
      handleTagsClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.tags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
		},
		created() {
			let s = gettoken("token");
			let username = localStorage.getItem('username');
			this.tk = s;
			this.kkk = username;
			if (s && username) {
				this.dl = false;
				this.tuichu = true;
				this.$message({
					message: "登录成功",
					type: "success",
					duration: 1000,
				});
			}
			GetTypes({}).then((res) => {
				if (res.code == "0") {
					this.$message.error("获取分类失败");
				}
				if (res.code == "1") {
					this.types = res.data;
				}
			});
		}
	};
</script>

<style scoped>
	/deep/ .el-textarea__inner {
		height: 90px !important;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>